import React from 'react';
import { CTAButton } from './CTAButton';
export function MidPageCTA() {
  return <section className="py-8 px-4 bg-white" data-id="element-80" data-mp="1vth3kgjbs94v">
      <div className="max-w-3xl mx-auto text-center" data-id="element-81" data-mp="1vs624ndcrdgx">
        <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4" data-id="element-82" data-mp="20kh2frc091a0">
          Accedé ahora al material completo
        </h2>
        <CTAButton href="#compra" className="w-full md:w-auto" data-id="element-83" data-mp="25i8v4nkh4rf9">
          OBTENER ACCESO INMEDIATO
        </CTAButton>
      </div>
    </section>;
}